/**********************************************************************
 * WARNING: This file is auto-generated. Do not edit directly.
 * This file is generated by the script located in value-type-definitions/scripts
 * and should not be modified manually.
 ***********************************************************************/

export const valueTypesTimeseries = [
  {
    id: 'almondBloom',
    value_type_group_id: 'almond_bloom',
    section_id: 'crop_development',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_BLOOM_PREDICTION',
    unit_classification_id: 'BLOOM_PERCENT',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'almondHullSplit',
    value_type_group_id: 'almond_hull_split',
    section_id: 'crop_development',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_ALMOND_HULL_SPLIT_SUMMARY',
    unit_classification_id: 'HULL_SPLIT',
    field_asset: 'blocks',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'almondHullSplit',
    value_type_group_id: 'almond_hull_split',
    section_id: 'crop_development',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_ALMOND_HULL_SPLIT_SUMMARY',
    unit_classification_id: 'HULL_SPLIT',
    field_asset: 'properties',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'alternaria',
    value_type_group_id: 'alternaria',
    section_id: 'diseases',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_ALTERNARIA_DETAILS',
    unit_classification_id: 'ALTERNARIA_RISK',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'alternariaCumulativeRolling7Days',
    value_type_group_id: 'alternaria',
    section_id: 'diseases',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_ALTERNARIA_DETAILS',
    unit_classification_id: 'ALTERNARIA_RISK',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'beeHours',
    value_type_group_id: 'bee_hours',
    section_id: 'crop_development',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_BEE_HOURS_DETAILS',
    unit_classification_id: 'BEE_HOURS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'beeHours',
    value_type_group_id: 'bee_hours',
    section_id: 'crop_development',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_BEE_HOURS_DETAILS',
    unit_classification_id: 'BEE_HOURS',
    field_asset: 'blocks',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'cherryPowderyMildewModelPredictedRisk',
    value_type_group_id: 'cherry_powdery_mildew',
    section_id: 'diseases',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_CHERRY_POWDERY_MILDEW_DETAILS',
    unit_classification_id: 'CHERRY_POWDERY_MILDEW_RISK',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'chillCumulativeHoursBelow45FMAR',
    value_type_group_id: 'chill',
    section_id: 'crop_development',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'CHILL',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'chillCumulativeHoursBelow45FMAY',
    value_type_group_id: 'chill',
    section_id: 'crop_development',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'CHILL',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'chillCumulativeHoursBelow45FNOV',
    value_type_group_id: 'chill',
    section_id: 'crop_development',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'CHILL',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'chillCumulativeHoursBelow45FSEP',
    value_type_group_id: 'chill',
    section_id: 'crop_development',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'CHILL',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'chillCumulativeHoursBetween32and45FMAR',
    value_type_group_id: 'chill',
    section_id: 'crop_development',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'CHILL',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'chillCumulativeHoursBetween32and45FMAY',
    value_type_group_id: 'chill',
    section_id: 'crop_development',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'CHILL',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'chillCumulativeHoursBetween32and45FNOV',
    value_type_group_id: 'chill',
    section_id: 'crop_development',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'CHILL',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'chillCumulativeHoursBetween32and45FSEP',
    value_type_group_id: 'chill',
    section_id: 'crop_development',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'CHILL',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'chillCumulativePortionsMAR',
    value_type_group_id: 'chill',
    section_id: 'crop_development',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'CHILL',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'chillCumulativePortionsMAY',
    value_type_group_id: 'chill',
    section_id: 'crop_development',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'CHILL',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'chillCumulativePortionsNOV',
    value_type_group_id: 'chill',
    section_id: 'crop_development',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'CHILL',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'chillCumulativePortionsSEP',
    value_type_group_id: 'chill',
    section_id: 'crop_development',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'CHILL',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'chillHoursBelow45F',
    value_type_group_id: 'chill',
    section_id: 'crop_development',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'CHILL',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'chillHoursBetween32and45F',
    value_type_group_id: 'chill',
    section_id: 'crop_development',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'CHILL',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'chillPortions',
    value_type_group_id: 'chill',
    section_id: 'crop_development',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'CHILL',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'cropDegreeDaysCumulativeSinceBiofix_3',
    value_type_group_id: 'degree_days_crop_id_3',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_CHERRY_POWDERY_MILDEW_DETAILS',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'cropDegreeDaysCumulativeSinceBiofix_5',
    value_type_group_id: 'degree_days_crop_id_5',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_GRAPE_POWDERY_MILDEW_DETAILS',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'cropDegreeDaysCumulativeSinceBiofix_11',
    value_type_group_id: 'degree_days_crop_id_11',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_CHERRY_POWDERY_MILDEW_DETAILS',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'cropDegreeDaysCumulativeSinceBiofix_12',
    value_type_group_id: 'degree_days_crop_id_12',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_CHERRY_POWDERY_MILDEW_DETAILS',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'dewDifferential_ABOVE',
    value_type_group_id: 'dew_point',
    section_id: 'weather',
    required_measurements: ['air-temperature-above', 'relative-humidity-above'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'dewDifferential_ABOVE',
    value_type_group_id: 'dew_point',
    section_id: 'weather',
    required_measurements: ['air-temperature-above', 'relative-humidity-above'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: false,
  },
  {
    id: 'dewDifferential_ABOVE',
    value_type_group_id: 'dew_point',
    section_id: 'weather',
    required_measurements: ['air-temperature-above', 'relative-humidity-above'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'dewDifferential_BELOW',
    value_type_group_id: 'dew_point',
    section_id: 'weather',
    required_measurements: ['air-temperature-below', 'relative-humidity-below'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'dewDifferential_BELOW',
    value_type_group_id: 'dew_point',
    section_id: 'weather',
    required_measurements: ['air-temperature-below', 'relative-humidity-below'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: false,
  },
  {
    id: 'dewDifferential_BELOW',
    value_type_group_id: 'dew_point',
    section_id: 'weather',
    required_measurements: ['air-temperature-below', 'relative-humidity-below'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'dewDifferential_IN',
    value_type_group_id: 'dew_point',
    section_id: 'weather',
    required_measurements: ['air-temperature-in', 'relative-humidity-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'dewDifferential_IN',
    value_type_group_id: 'dew_point',
    section_id: 'weather',
    required_measurements: ['air-temperature-in', 'relative-humidity-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: false,
  },
  {
    id: 'dewDifferential_IN',
    value_type_group_id: 'dew_point',
    section_id: 'weather',
    required_measurements: ['air-temperature-in', 'relative-humidity-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'dewPoint_ABOVE',
    value_type_group_id: 'dew_point',
    section_id: 'weather',
    required_measurements: ['air-temperature-above', 'relative-humidity-above'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'dewPoint_ABOVE',
    value_type_group_id: 'dew_point',
    section_id: 'weather',
    required_measurements: ['air-temperature-above', 'relative-humidity-above'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'dewPoint_ABOVE',
    value_type_group_id: 'dew_point',
    section_id: 'weather',
    required_measurements: ['air-temperature-above', 'relative-humidity-above'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'dewPoint_BELOW',
    value_type_group_id: 'dew_point',
    section_id: 'weather',
    required_measurements: ['air-temperature-below', 'relative-humidity-below'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'dewPoint_BELOW',
    value_type_group_id: 'dew_point',
    section_id: 'weather',
    required_measurements: ['air-temperature-below', 'relative-humidity-below'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'dewPoint_BELOW',
    value_type_group_id: 'dew_point',
    section_id: 'weather',
    required_measurements: ['air-temperature-below', 'relative-humidity-below'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'dewPoint_IN',
    value_type_group_id: 'dew_point',
    section_id: 'weather',
    required_measurements: ['air-temperature-in', 'relative-humidity-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'dewPoint_IN',
    value_type_group_id: 'dew_point',
    section_id: 'weather',
    required_measurements: ['air-temperature-in', 'relative-humidity-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'dewPoint_IN',
    value_type_group_id: 'dew_point',
    section_id: 'weather',
    required_measurements: ['air-temperature-in', 'relative-humidity-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'dewPoint_IN',
    value_type_group_id: 'dew_point',
    section_id: 'weather',
    required_measurements: ['air-temperature-in', 'relative-humidity-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'dewPoint_IN',
    value_type_group_id: 'dew_point',
    section_id: 'weather',
    required_measurements: ['air-temperature-in', 'relative-humidity-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'regions',
    aggregation: 'HOURLY',
    is_available_for_data_export: false,
  },
  {
    id: 'dewPoint_IN',
    value_type_group_id: 'dew_point',
    section_id: 'weather',
    required_measurements: ['air-temperature-in', 'relative-humidity-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'regions',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'evapotranspirationETc',
    value_type_group_id: 'evapotranspiration',
    section_id: 'water_management',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_EVAPOTRANSPIRATION_DETAILS',
    unit_classification_id: 'EVAPOTRANSPIRATION_ETC',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'evapotranspirationETo',
    value_type_group_id: 'evapotranspiration',
    section_id: 'water_management',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_EVAPOTRANSPIRATION_DETAILS',
    unit_classification_id: 'EVAPOTRANSPIRATION_ETO',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'evapotranspirationKc',
    value_type_group_id: 'evapotranspiration',
    section_id: 'water_management',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_EVAPOTRANSPIRATION_DETAILS',
    unit_classification_id: 'EVAPOTRANSPIRATION_KC',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'fireBlightTRV',
    value_type_group_id: 'fire_blight',
    section_id: 'diseases',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_FIRE_BLIGHT_DETAILS',
    unit_classification_id: 'FIRE_BLIGHT_RISK',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'fireBlightTRV',
    value_type_group_id: 'fire_blight',
    section_id: 'diseases',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_FIRE_BLIGHT_DETAILS',
    unit_classification_id: 'FIRE_BLIGHT_RISK',
    field_asset: 'blocks',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'fruitGrowth',
    value_type_group_id: 'fruit_growth',
    section_id: 'water_management',
    required_measurements: ['fruit-dendrometer'],
    permission_id: 'VIEW_FRUIT_GROWTH_DETAILS',
    unit_classification_id: 'FRUIT_GROWTH',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'fruitSize',
    value_type_group_id: 'fruit_growth',
    section_id: 'water_management',
    required_measurements: ['fruit-dendrometer'],
    permission_id: 'VIEW_FRUIT_GROWTH_DETAILS',
    unit_classification_id: 'FRUIT_SIZE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'fruitSize',
    value_type_group_id: 'fruit_growth',
    section_id: 'water_management',
    required_measurements: ['fruit-dendrometer'],
    permission_id: 'VIEW_FRUIT_GROWTH_DETAILS',
    unit_classification_id: 'FRUIT_SIZE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'fruitSize',
    value_type_group_id: 'fruit_growth',
    section_id: 'water_management',
    required_measurements: ['fruit-dendrometer'],
    permission_id: 'VIEW_FRUIT_GROWTH_DETAILS',
    unit_classification_id: 'FRUIT_SIZE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'fruitSizeTarget',
    value_type_group_id: 'fruit_growth',
    section_id: 'water_management',
    required_measurements: ['fruit-dendrometer'],
    permission_id: 'VIEW_FRUIT_GROWTH_DETAILS',
    unit_classification_id: 'FRUIT_SIZE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'grapePowderyMildewModelPredictedRisk',
    value_type_group_id: 'grape_powdery_mildew',
    section_id: 'diseases',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_GRAPE_POWDERY_MILDEW_DETAILS',
    unit_classification_id: 'GRAPE_POWDERY_MILDEW_RISK',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'humidity_ABOVE',
    value_type_group_id: 'humidity',
    section_id: 'weather',
    required_measurements: ['relative-humidity-above'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'HUMIDITY',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'humidity_ABOVE',
    value_type_group_id: 'humidity',
    section_id: 'weather',
    required_measurements: ['relative-humidity-above'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'HUMIDITY',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'humidity_ABOVE',
    value_type_group_id: 'humidity',
    section_id: 'weather',
    required_measurements: ['relative-humidity-above'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'HUMIDITY',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'humidity_BELOW',
    value_type_group_id: 'humidity',
    section_id: 'weather',
    required_measurements: ['relative-humidity-below'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'HUMIDITY',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'humidity_BELOW',
    value_type_group_id: 'humidity',
    section_id: 'weather',
    required_measurements: ['relative-humidity-below'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'HUMIDITY',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'humidity_BELOW',
    value_type_group_id: 'humidity',
    section_id: 'weather',
    required_measurements: ['relative-humidity-below'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'HUMIDITY',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'humidity_IN',
    value_type_group_id: 'humidity',
    section_id: 'weather',
    required_measurements: ['relative-humidity-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'HUMIDITY',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'humidity_IN',
    value_type_group_id: 'humidity',
    section_id: 'weather',
    required_measurements: ['relative-humidity-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'HUMIDITY',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'humidity_IN',
    value_type_group_id: 'humidity',
    section_id: 'weather',
    required_measurements: ['relative-humidity-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'HUMIDITY',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'humidity_IN',
    value_type_group_id: 'humidity',
    section_id: 'weather',
    required_measurements: ['relative-humidity-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'HUMIDITY',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'humidity_IN',
    value_type_group_id: 'humidity',
    section_id: 'weather',
    required_measurements: ['relative-humidity-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'HUMIDITY',
    field_asset: 'regions',
    aggregation: 'HOURLY',
    is_available_for_data_export: false,
  },
  {
    id: 'humidity_IN',
    value_type_group_id: 'humidity',
    section_id: 'weather',
    required_measurements: ['relative-humidity-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'HUMIDITY',
    field_asset: 'regions',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_1',
    value_type_group_id: 'degree_days_insect_id_1',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_1',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_1',
    value_type_group_id: 'degree_days_insect_id_1',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_1',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_1',
    value_type_group_id: 'degree_days_insect_id_1',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_1',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_2',
    value_type_group_id: 'degree_days_insect_id_2',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_2',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_2',
    value_type_group_id: 'degree_days_insect_id_2',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_2',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_2',
    value_type_group_id: 'degree_days_insect_id_2',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_2',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_3',
    value_type_group_id: 'degree_days_insect_id_3',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_3',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_3',
    value_type_group_id: 'degree_days_insect_id_3',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_3',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_3',
    value_type_group_id: 'degree_days_insect_id_3',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_3',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_4',
    value_type_group_id: 'degree_days_insect_id_4',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_4',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_4',
    value_type_group_id: 'degree_days_insect_id_4',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_4',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_4',
    value_type_group_id: 'degree_days_insect_id_4',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_4',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_6',
    value_type_group_id: 'degree_days_insect_id_6',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_6',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_6',
    value_type_group_id: 'degree_days_insect_id_6',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_6',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_6',
    value_type_group_id: 'degree_days_insect_id_6',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_6',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_7',
    value_type_group_id: 'degree_days_insect_id_7',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_7',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_7',
    value_type_group_id: 'degree_days_insect_id_7',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_7',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_7',
    value_type_group_id: 'degree_days_insect_id_7',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_7',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_8',
    value_type_group_id: 'degree_days_insect_id_8',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_8',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_8',
    value_type_group_id: 'degree_days_insect_id_8',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_8',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_8',
    value_type_group_id: 'degree_days_insect_id_8',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_8',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_9',
    value_type_group_id: 'degree_days_insect_id_9',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_9',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_9',
    value_type_group_id: 'degree_days_insect_id_9',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_9',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_9',
    value_type_group_id: 'degree_days_insect_id_9',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_9',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_10',
    value_type_group_id: 'degree_days_insect_id_10',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_10',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_10',
    value_type_group_id: 'degree_days_insect_id_10',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_10',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_10',
    value_type_group_id: 'degree_days_insect_id_10',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_10',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_11',
    value_type_group_id: 'degree_days_insect_id_11',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_11',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_11',
    value_type_group_id: 'degree_days_insect_id_11',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_11',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_11',
    value_type_group_id: 'degree_days_insect_id_11',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_11',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_12',
    value_type_group_id: 'degree_days_insect_id_12',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_12',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_12',
    value_type_group_id: 'degree_days_insect_id_12',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_12',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_12',
    value_type_group_id: 'degree_days_insect_id_12',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_12',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_13',
    value_type_group_id: 'degree_days_insect_id_13',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_13',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_13',
    value_type_group_id: 'degree_days_insect_id_13',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_13',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_13',
    value_type_group_id: 'degree_days_insect_id_13',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_13',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_14',
    value_type_group_id: 'degree_days_insect_id_14',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_14',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_14',
    value_type_group_id: 'degree_days_insect_id_14',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_14',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_14',
    value_type_group_id: 'degree_days_insect_id_14',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_14',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_15',
    value_type_group_id: 'degree_days_insect_id_15',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_15',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_15',
    value_type_group_id: 'degree_days_insect_id_15',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_15',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_15',
    value_type_group_id: 'degree_days_insect_id_15',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_15',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_16',
    value_type_group_id: 'degree_days_insect_id_16',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_16',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_16',
    value_type_group_id: 'degree_days_insect_id_16',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_16',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_16',
    value_type_group_id: 'degree_days_insect_id_16',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_16',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_17',
    value_type_group_id: 'degree_days_insect_id_17',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_17',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_17',
    value_type_group_id: 'degree_days_insect_id_17',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_17',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_17',
    value_type_group_id: 'degree_days_insect_id_17',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_17',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_18',
    value_type_group_id: 'degree_days_insect_id_18',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_18',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_18',
    value_type_group_id: 'degree_days_insect_id_18',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_18',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_18',
    value_type_group_id: 'degree_days_insect_id_18',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_18',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_19',
    value_type_group_id: 'degree_days_insect_id_19',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_19',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_19',
    value_type_group_id: 'degree_days_insect_id_19',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_19',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_19',
    value_type_group_id: 'degree_days_insect_id_19',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_19',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_20',
    value_type_group_id: 'degree_days_insect_id_20',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_20',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_20',
    value_type_group_id: 'degree_days_insect_id_20',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_20',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_20',
    value_type_group_id: 'degree_days_insect_id_20',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_20',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_23',
    value_type_group_id: 'degree_days_insect_id_23',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_23',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_23',
    value_type_group_id: 'degree_days_insect_id_23',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_23',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_23',
    value_type_group_id: 'degree_days_insect_id_23',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_23',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_24',
    value_type_group_id: 'degree_days_insect_id_24',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_24',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_24',
    value_type_group_id: 'degree_days_insect_id_24',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_24',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_24',
    value_type_group_id: 'degree_days_insect_id_24',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_24',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_25',
    value_type_group_id: 'degree_days_insect_id_25',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_25',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_25',
    value_type_group_id: 'degree_days_insect_id_25',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_25',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_25',
    value_type_group_id: 'degree_days_insect_id_25',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_25',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_26',
    value_type_group_id: 'degree_days_insect_id_26',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_26',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_26',
    value_type_group_id: 'degree_days_insect_id_26',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_26',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_26',
    value_type_group_id: 'degree_days_insect_id_26',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_26',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_27',
    value_type_group_id: 'degree_days_insect_id_27',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_27',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_27',
    value_type_group_id: 'degree_days_insect_id_27',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_27',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_27',
    value_type_group_id: 'degree_days_insect_id_27',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_27',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_28',
    value_type_group_id: 'degree_days_insect_id_28',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_28',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_28',
    value_type_group_id: 'degree_days_insect_id_28',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_28',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_28',
    value_type_group_id: 'degree_days_insect_id_28',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_28',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_29',
    value_type_group_id: 'degree_days_insect_id_29',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_29',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_29',
    value_type_group_id: 'degree_days_insect_id_29',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_29',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_29',
    value_type_group_id: 'degree_days_insect_id_29',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_29',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_30',
    value_type_group_id: 'degree_days_insect_id_30',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_30',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_30',
    value_type_group_id: 'degree_days_insect_id_30',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_30',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDays_30',
    value_type_group_id: 'degree_days_insect_id_30',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_30',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_1',
    value_type_group_id: 'degree_days_insect_id_1',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_1',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_1',
    value_type_group_id: 'degree_days_insect_id_1',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_1',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_1',
    value_type_group_id: 'degree_days_insect_id_1',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_1',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_2',
    value_type_group_id: 'degree_days_insect_id_2',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_2',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_2',
    value_type_group_id: 'degree_days_insect_id_2',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_2',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_2',
    value_type_group_id: 'degree_days_insect_id_2',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_2',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_3',
    value_type_group_id: 'degree_days_insect_id_3',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_3',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_3',
    value_type_group_id: 'degree_days_insect_id_3',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_3',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_3',
    value_type_group_id: 'degree_days_insect_id_3',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_3',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_4',
    value_type_group_id: 'degree_days_insect_id_4',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_4',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_4',
    value_type_group_id: 'degree_days_insect_id_4',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_4',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_4',
    value_type_group_id: 'degree_days_insect_id_4',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_4',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_6',
    value_type_group_id: 'degree_days_insect_id_6',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_6',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_6',
    value_type_group_id: 'degree_days_insect_id_6',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_6',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_6',
    value_type_group_id: 'degree_days_insect_id_6',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_6',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_7',
    value_type_group_id: 'degree_days_insect_id_7',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_7',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_7',
    value_type_group_id: 'degree_days_insect_id_7',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_7',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_7',
    value_type_group_id: 'degree_days_insect_id_7',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_7',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_8',
    value_type_group_id: 'degree_days_insect_id_8',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_8',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_8',
    value_type_group_id: 'degree_days_insect_id_8',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_8',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_8',
    value_type_group_id: 'degree_days_insect_id_8',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_8',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_9',
    value_type_group_id: 'degree_days_insect_id_9',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_9',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_9',
    value_type_group_id: 'degree_days_insect_id_9',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_9',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_9',
    value_type_group_id: 'degree_days_insect_id_9',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_9',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_10',
    value_type_group_id: 'degree_days_insect_id_10',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_10',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_10',
    value_type_group_id: 'degree_days_insect_id_10',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_10',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_10',
    value_type_group_id: 'degree_days_insect_id_10',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_10',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_11',
    value_type_group_id: 'degree_days_insect_id_11',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_11',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_11',
    value_type_group_id: 'degree_days_insect_id_11',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_11',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_11',
    value_type_group_id: 'degree_days_insect_id_11',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_11',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_12',
    value_type_group_id: 'degree_days_insect_id_12',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_12',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_12',
    value_type_group_id: 'degree_days_insect_id_12',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_12',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_12',
    value_type_group_id: 'degree_days_insect_id_12',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_12',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_13',
    value_type_group_id: 'degree_days_insect_id_13',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_13',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_13',
    value_type_group_id: 'degree_days_insect_id_13',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_13',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_13',
    value_type_group_id: 'degree_days_insect_id_13',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_13',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_14',
    value_type_group_id: 'degree_days_insect_id_14',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_14',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_14',
    value_type_group_id: 'degree_days_insect_id_14',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_14',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_14',
    value_type_group_id: 'degree_days_insect_id_14',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_14',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_15',
    value_type_group_id: 'degree_days_insect_id_15',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_15',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_15',
    value_type_group_id: 'degree_days_insect_id_15',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_15',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_15',
    value_type_group_id: 'degree_days_insect_id_15',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_15',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_16',
    value_type_group_id: 'degree_days_insect_id_16',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_16',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_16',
    value_type_group_id: 'degree_days_insect_id_16',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_16',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_16',
    value_type_group_id: 'degree_days_insect_id_16',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_16',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_17',
    value_type_group_id: 'degree_days_insect_id_17',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_17',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_17',
    value_type_group_id: 'degree_days_insect_id_17',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_17',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_17',
    value_type_group_id: 'degree_days_insect_id_17',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_17',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_18',
    value_type_group_id: 'degree_days_insect_id_18',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_18',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_18',
    value_type_group_id: 'degree_days_insect_id_18',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_18',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_18',
    value_type_group_id: 'degree_days_insect_id_18',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_18',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_19',
    value_type_group_id: 'degree_days_insect_id_19',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_19',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_19',
    value_type_group_id: 'degree_days_insect_id_19',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_19',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_19',
    value_type_group_id: 'degree_days_insect_id_19',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_19',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_20',
    value_type_group_id: 'degree_days_insect_id_20',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_20',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_20',
    value_type_group_id: 'degree_days_insect_id_20',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_20',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_20',
    value_type_group_id: 'degree_days_insect_id_20',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_20',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_23',
    value_type_group_id: 'degree_days_insect_id_23',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_23',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_23',
    value_type_group_id: 'degree_days_insect_id_23',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_23',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_23',
    value_type_group_id: 'degree_days_insect_id_23',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_23',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_24',
    value_type_group_id: 'degree_days_insect_id_24',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_24',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_24',
    value_type_group_id: 'degree_days_insect_id_24',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_24',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_24',
    value_type_group_id: 'degree_days_insect_id_24',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_24',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_25',
    value_type_group_id: 'degree_days_insect_id_25',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_25',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_25',
    value_type_group_id: 'degree_days_insect_id_25',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_25',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_25',
    value_type_group_id: 'degree_days_insect_id_25',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_25',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_26',
    value_type_group_id: 'degree_days_insect_id_26',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_26',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_26',
    value_type_group_id: 'degree_days_insect_id_26',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_26',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_26',
    value_type_group_id: 'degree_days_insect_id_26',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_26',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_27',
    value_type_group_id: 'degree_days_insect_id_27',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_27',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_27',
    value_type_group_id: 'degree_days_insect_id_27',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_27',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_27',
    value_type_group_id: 'degree_days_insect_id_27',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_27',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_28',
    value_type_group_id: 'degree_days_insect_id_28',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_28',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_28',
    value_type_group_id: 'degree_days_insect_id_28',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_28',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_28',
    value_type_group_id: 'degree_days_insect_id_28',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_28',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_29',
    value_type_group_id: 'degree_days_insect_id_29',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_29',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_29',
    value_type_group_id: 'degree_days_insect_id_29',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_29',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_29',
    value_type_group_id: 'degree_days_insect_id_29',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_29',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_30',
    value_type_group_id: 'degree_days_insect_id_30',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_30',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_30',
    value_type_group_id: 'degree_days_insect_id_30',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_30',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectDegreeDaysCumulativeSinceBiofix_30',
    value_type_group_id: 'degree_days_insect_id_30',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_DEGREE_DAYS_ID_30',
    unit_classification_id: 'DEGREE_DAYS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectLarvalTrend_1',
    value_type_group_id: 'larval_trend_id_1',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-1'],
    permission_id: 'VIEW_PESTS_LARVAL_TREND_ID_1',
    unit_classification_id: 'LARVAL_TREND',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectLarvalTrend_1',
    value_type_group_id: 'larval_trend_id_1',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-1'],
    permission_id: 'VIEW_PESTS_LARVAL_TREND_ID_1',
    unit_classification_id: 'LARVAL_TREND',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectLarvalTrend_2',
    value_type_group_id: 'larval_trend_id_2',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-2'],
    permission_id: 'VIEW_PESTS_LARVAL_TREND_ID_2',
    unit_classification_id: 'LARVAL_TREND',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectLarvalTrend_2',
    value_type_group_id: 'larval_trend_id_2',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-2'],
    permission_id: 'VIEW_PESTS_LARVAL_TREND_ID_2',
    unit_classification_id: 'LARVAL_TREND',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectLarvalTrend_6',
    value_type_group_id: 'larval_trend_id_6',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-6'],
    permission_id: 'VIEW_PESTS_LARVAL_TREND_ID_6',
    unit_classification_id: 'LARVAL_TREND',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectLarvalTrend_6',
    value_type_group_id: 'larval_trend_id_6',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-6'],
    permission_id: 'VIEW_PESTS_LARVAL_TREND_ID_6',
    unit_classification_id: 'LARVAL_TREND',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectLarvalTrend_7',
    value_type_group_id: 'larval_trend_id_7',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-7'],
    permission_id: 'VIEW_PESTS_LARVAL_TREND_ID_7',
    unit_classification_id: 'LARVAL_TREND',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectLarvalTrend_7',
    value_type_group_id: 'larval_trend_id_7',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-7'],
    permission_id: 'VIEW_PESTS_LARVAL_TREND_ID_7',
    unit_classification_id: 'LARVAL_TREND',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectLarvalTrend_9',
    value_type_group_id: 'larval_trend_id_9',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-9'],
    permission_id: 'VIEW_PESTS_LARVAL_TREND_ID_9',
    unit_classification_id: 'LARVAL_TREND',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectLarvalTrend_9',
    value_type_group_id: 'larval_trend_id_9',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-9'],
    permission_id: 'VIEW_PESTS_LARVAL_TREND_ID_9',
    unit_classification_id: 'LARVAL_TREND',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectLarvalTrend_11',
    value_type_group_id: 'larval_trend_id_11',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-11'],
    permission_id: 'VIEW_PESTS_LARVAL_TREND_ID_11',
    unit_classification_id: 'LARVAL_TREND',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectLarvalTrend_11',
    value_type_group_id: 'larval_trend_id_11',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-11'],
    permission_id: 'VIEW_PESTS_LARVAL_TREND_ID_11',
    unit_classification_id: 'LARVAL_TREND',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectLarvalTrend_20',
    value_type_group_id: 'larval_trend_id_20',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-20'],
    permission_id: 'VIEW_PESTS_LARVAL_TREND_ID_20',
    unit_classification_id: 'LARVAL_TREND',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectLarvalTrend_20',
    value_type_group_id: 'larval_trend_id_20',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-20'],
    permission_id: 'VIEW_PESTS_LARVAL_TREND_ID_20',
    unit_classification_id: 'LARVAL_TREND',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectPhenology_1',
    value_type_group_id: 'phenology_insect_id_1',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_PHENOLOGY_ID_1',
    unit_classification_id: 'LARVAL_TREND',
    field_asset: 'properties',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'insectPhenology_7',
    value_type_group_id: 'phenology_insect_id_7',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-7', 'air-temperature-in'],
    permission_id: 'VIEW_PESTS_PHENOLOGY_ID_7',
    unit_classification_id: 'LARVAL_TREND',
    field_asset: 'properties',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'insectPhenology_11',
    value_type_group_id: 'phenology_insect_id_11',
    section_id: 'pests',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_PESTS_PHENOLOGY_ID_11',
    unit_classification_id: 'LARVAL_TREND',
    field_asset: 'properties',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_1',
    value_type_group_id: 'trap_catches_insect_id_1',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-1'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_1',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_1',
    value_type_group_id: 'trap_catches_insect_id_1',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-1'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_1',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_1',
    value_type_group_id: 'trap_catches_insect_id_1',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-1'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_1',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_1',
    value_type_group_id: 'trap_catches_insect_id_1',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-1'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_1',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_2',
    value_type_group_id: 'trap_catches_insect_id_2',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-2'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_2',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_2',
    value_type_group_id: 'trap_catches_insect_id_2',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-2'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_2',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_2',
    value_type_group_id: 'trap_catches_insect_id_2',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-2'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_2',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_2',
    value_type_group_id: 'trap_catches_insect_id_2',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-2'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_2',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_6',
    value_type_group_id: 'trap_catches_insect_id_6',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-6'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_6',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_6',
    value_type_group_id: 'trap_catches_insect_id_6',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-6'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_6',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_6',
    value_type_group_id: 'trap_catches_insect_id_6',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-6'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_6',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_6',
    value_type_group_id: 'trap_catches_insect_id_6',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-6'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_6',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_7',
    value_type_group_id: 'trap_catches_insect_id_7',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-7'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_7',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_7',
    value_type_group_id: 'trap_catches_insect_id_7',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-7'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_7',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_7',
    value_type_group_id: 'trap_catches_insect_id_7',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-7'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_7',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_7',
    value_type_group_id: 'trap_catches_insect_id_7',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-7'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_7',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_9',
    value_type_group_id: 'trap_catches_insect_id_9',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-9'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_9',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_9',
    value_type_group_id: 'trap_catches_insect_id_9',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-9'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_9',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_9',
    value_type_group_id: 'trap_catches_insect_id_9',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-9'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_9',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_9',
    value_type_group_id: 'trap_catches_insect_id_9',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-9'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_9',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_10',
    value_type_group_id: 'trap_catches_insect_id_10',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-10'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_10',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_10',
    value_type_group_id: 'trap_catches_insect_id_10',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-10'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_10',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_10',
    value_type_group_id: 'trap_catches_insect_id_10',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-10'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_10',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_10',
    value_type_group_id: 'trap_catches_insect_id_10',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-10'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_10',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_11',
    value_type_group_id: 'trap_catches_insect_id_11',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-11'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_11',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_11',
    value_type_group_id: 'trap_catches_insect_id_11',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-11'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_11',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_11',
    value_type_group_id: 'trap_catches_insect_id_11',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-11'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_11',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_11',
    value_type_group_id: 'trap_catches_insect_id_11',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-11'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_11',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_12',
    value_type_group_id: 'trap_catches_insect_id_12',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-12'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_12',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_12',
    value_type_group_id: 'trap_catches_insect_id_12',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-12'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_12',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_12',
    value_type_group_id: 'trap_catches_insect_id_12',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-12'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_12',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_12',
    value_type_group_id: 'trap_catches_insect_id_12',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-12'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_12',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_15',
    value_type_group_id: 'trap_catches_insect_id_15',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-15'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_15',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_15',
    value_type_group_id: 'trap_catches_insect_id_15',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-15'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_15',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_15',
    value_type_group_id: 'trap_catches_insect_id_15',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-15'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_15',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_15',
    value_type_group_id: 'trap_catches_insect_id_15',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-15'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_15',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_16',
    value_type_group_id: 'trap_catches_insect_id_16',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-16'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_16',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_16',
    value_type_group_id: 'trap_catches_insect_id_16',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-16'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_16',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_16',
    value_type_group_id: 'trap_catches_insect_id_16',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-16'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_16',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_16',
    value_type_group_id: 'trap_catches_insect_id_16',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-16'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_16',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_17',
    value_type_group_id: 'trap_catches_insect_id_17',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-17'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_17',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_17',
    value_type_group_id: 'trap_catches_insect_id_17',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-17'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_17',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_17',
    value_type_group_id: 'trap_catches_insect_id_17',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-17'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_17',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_17',
    value_type_group_id: 'trap_catches_insect_id_17',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-17'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_17',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_19',
    value_type_group_id: 'trap_catches_insect_id_19',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-19'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_19',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_19',
    value_type_group_id: 'trap_catches_insect_id_19',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-19'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_19',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_19',
    value_type_group_id: 'trap_catches_insect_id_19',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-19'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_19',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_19',
    value_type_group_id: 'trap_catches_insect_id_19',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-19'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_19',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_20',
    value_type_group_id: 'trap_catches_insect_id_20',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-20'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_20',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_20',
    value_type_group_id: 'trap_catches_insect_id_20',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-20'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_20',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_20',
    value_type_group_id: 'trap_catches_insect_id_20',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-20'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_20',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_20',
    value_type_group_id: 'trap_catches_insect_id_20',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-20'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_20',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_25',
    value_type_group_id: 'trap_catches_insect_id_25',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-25'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_25',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_25',
    value_type_group_id: 'trap_catches_insect_id_25',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-25'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_25',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_25',
    value_type_group_id: 'trap_catches_insect_id_25',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-25'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_25',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_25',
    value_type_group_id: 'trap_catches_insect_id_25',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-25'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_25',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_27',
    value_type_group_id: 'trap_catches_insect_id_27',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-27'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_27',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_27',
    value_type_group_id: 'trap_catches_insect_id_27',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-27'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_27',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_27',
    value_type_group_id: 'trap_catches_insect_id_27',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-27'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_27',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_27',
    value_type_group_id: 'trap_catches_insect_id_27',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-27'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_27',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_28',
    value_type_group_id: 'trap_catches_insect_id_28',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-28'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_28',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_28',
    value_type_group_id: 'trap_catches_insect_id_28',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-28'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_28',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_28',
    value_type_group_id: 'trap_catches_insect_id_28',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-28'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_28',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_28',
    value_type_group_id: 'trap_catches_insect_id_28',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-28'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_28',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_29',
    value_type_group_id: 'trap_catches_insect_id_29',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-29'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_29',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_29',
    value_type_group_id: 'trap_catches_insect_id_29',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-29'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_29',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_29',
    value_type_group_id: 'trap_catches_insect_id_29',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-29'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_29',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_29',
    value_type_group_id: 'trap_catches_insect_id_29',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-29'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_29',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_30',
    value_type_group_id: 'trap_catches_insect_id_30',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-30'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_30',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_30',
    value_type_group_id: 'trap_catches_insect_id_30',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-30'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_30',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'insectTrapCatches_30',
    value_type_group_id: 'trap_catches_insect_id_30',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-30'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_30',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'properties',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatches_30',
    value_type_group_id: 'trap_catches_insect_id_30',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-30'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_30',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatchesPercentage_1',
    value_type_group_id: 'trap_catches_insect_id_1',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-1'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_1',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatchesPercentage_2',
    value_type_group_id: 'trap_catches_insect_id_2',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-2'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_2',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatchesPercentage_6',
    value_type_group_id: 'trap_catches_insect_id_6',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-6'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_6',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatchesPercentage_7',
    value_type_group_id: 'trap_catches_insect_id_7',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-7'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_7',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatchesPercentage_9',
    value_type_group_id: 'trap_catches_insect_id_9',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-9'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_9',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatchesPercentage_10',
    value_type_group_id: 'trap_catches_insect_id_10',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-10'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_10',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatchesPercentage_11',
    value_type_group_id: 'trap_catches_insect_id_11',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-11'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_11',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatchesPercentage_12',
    value_type_group_id: 'trap_catches_insect_id_12',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-12'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_12',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatchesPercentage_15',
    value_type_group_id: 'trap_catches_insect_id_15',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-15'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_15',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatchesPercentage_16',
    value_type_group_id: 'trap_catches_insect_id_16',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-16'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_16',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatchesPercentage_17',
    value_type_group_id: 'trap_catches_insect_id_17',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-17'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_17',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatchesPercentage_19',
    value_type_group_id: 'trap_catches_insect_id_19',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-19'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_19',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatchesPercentage_20',
    value_type_group_id: 'trap_catches_insect_id_20',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-20'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_20',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatchesPercentage_25',
    value_type_group_id: 'trap_catches_insect_id_25',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-25'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_25',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatchesPercentage_27',
    value_type_group_id: 'trap_catches_insect_id_27',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-27'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_27',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatchesPercentage_28',
    value_type_group_id: 'trap_catches_insect_id_28',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-28'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_28',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatchesPercentage_29',
    value_type_group_id: 'trap_catches_insect_id_29',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-29'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_29',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'insectTrapCatchesPercentage_30',
    value_type_group_id: 'trap_catches_insect_id_30',
    section_id: 'pests',
    required_measurements: ['insect-trap-catches-insect-id-30'],
    permission_id: 'VIEW_PESTS_TRAP_CATCHES_ID_30',
    unit_classification_id: 'TRAP_CATCHES',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_emitterBuriedDrip1',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-buried-drip-1'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_emitterBuriedDrip1',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-buried-drip-1'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_emitterBuriedDrip2',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-buried-drip-2'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_emitterBuriedDrip2',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-buried-drip-2'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_emitterDrip1',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-drip-1'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_emitterDrip1',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-drip-1'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_emitterDrip2',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-drip-2'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_emitterDrip2',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-drip-2'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_emitterFloodFurrow',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-flood-furrow'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_emitterFloodFurrow',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-flood-furrow'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_emitterMicrospray',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-microspray'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_emitterMicrospray',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-microspray'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_emitterOther',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-other'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_emitterOther',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-other'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_emitterOverheadCoolingMicrospray',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-overhead-cooling-microspray'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_emitterOverheadCoolingMicrospray',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-overhead-cooling-microspray'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_emitterOverheadCoolingSprinkler',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-overhead-cooling-sprinkler'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_emitterOverheadCoolingSprinkler',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-overhead-cooling-sprinkler'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_emitterSprinkler',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-sprinkler'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_emitterSprinkler',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-sprinkler'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_postFilter',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-post-filter'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_postFilter',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-post-filter'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_preFilter',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-pre-filter'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_preFilter',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-pre-filter'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_pump',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-pump'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_pump',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-pump'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_systemPressure',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-system-pressure'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityIntervalsSemios_systemPressure',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-system-pressure'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityPlannedIntervalsSemios_emitterBuriedDrip1',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-buried-drip-1'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityPlannedIntervalsSemios_emitterBuriedDrip2',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-buried-drip-2'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityPlannedIntervalsSemios_emitterDrip1',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-drip-1'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityPlannedIntervalsSemios_emitterDrip2',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-drip-2'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityPlannedIntervalsSemios_emitterFloodFurrow',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-flood-furrow'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityPlannedIntervalsSemios_emitterMicrospray',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-microspray'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityPlannedIntervalsSemios_emitterOther',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-other'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityPlannedIntervalsSemios_emitterOverheadCoolingMicrospray',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-overhead-cooling-microspray'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityPlannedIntervalsSemios_emitterOverheadCoolingSprinkler',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-overhead-cooling-sprinkler'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityPlannedIntervalsSemios_emitterSprinkler',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-sprinkler'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityPlannedIntervalsSemios_postFilter',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-post-filter'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityPlannedIntervalsSemios_preFilter',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-pre-filter'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityPlannedIntervalsSemios_pump',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-pump'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationActivityPlannedIntervalsSemios_systemPressure',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-system-pressure'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationFlowMeter',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['irrigation-flow-meter'],
    permission_id: 'VIEW_IRRIGATION_FLOW_METER_DETAILS',
    unit_classification_id: 'IRRIGATION_ACTIVITY',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationFlowMeter',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['irrigation-flow-meter'],
    permission_id: 'VIEW_IRRIGATION_FLOW_METER_DETAILS',
    unit_classification_id: 'IRRIGATION_ACTIVITY',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationFlowMeter',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['irrigation-flow-meter'],
    permission_id: 'VIEW_IRRIGATION_FLOW_METER_DETAILS',
    unit_classification_id: 'IRRIGATION_ACTIVITY',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationFlowRate',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['irrigation-flow-meter'],
    permission_id: 'VIEW_IRRIGATION_FLOW_METER_DETAILS',
    unit_classification_id: 'IRRIGATION_ACTIVITY',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationFlowRate',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['irrigation-flow-meter'],
    permission_id: 'VIEW_IRRIGATION_FLOW_METER_DETAILS',
    unit_classification_id: 'IRRIGATION_ACTIVITY',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationFlowRate',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['irrigation-flow-meter'],
    permission_id: 'VIEW_IRRIGATION_FLOW_METER_DETAILS',
    unit_classification_id: 'IRRIGATION_ACTIVITY',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPlannedVolumeDurationSemios_emitterBuriedDrip1',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-buried-drip-1'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPlannedVolumeDurationSemios_emitterBuriedDrip2',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-buried-drip-2'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPlannedVolumeDurationSemios_emitterDrip1',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-drip-1'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPlannedVolumeDurationSemios_emitterDrip2',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-drip-2'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPlannedVolumeDurationSemios_emitterFloodFurrow',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-flood-furrow'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPlannedVolumeDurationSemios_emitterMicrospray',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-microspray'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPlannedVolumeDurationSemios_emitterOther',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-other'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPlannedVolumeDurationSemios_emitterOverheadCoolingMicrospray',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-overhead-cooling-microspray'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPlannedVolumeDurationSemios_emitterOverheadCoolingSprinkler',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-overhead-cooling-sprinkler'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPlannedVolumeDurationSemios_emitterSprinkler',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-sprinkler'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPlannedVolumeDurationSemios_postFilter',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-post-filter'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPlannedVolumeDurationSemios_preFilter',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-pre-filter'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPlannedVolumeDurationSemios_pump',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-pump'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPlannedVolumeDurationSemios_systemPressure',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-system-pressure'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_INTERVAL',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_emitterBuriedDrip1',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-buried-drip-1'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationPressureSemios_emitterBuriedDrip1',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-buried-drip-1'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_emitterBuriedDrip1',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-buried-drip-1'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_emitterBuriedDrip2',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-buried-drip-2'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationPressureSemios_emitterBuriedDrip2',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-buried-drip-2'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_emitterBuriedDrip2',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-buried-drip-2'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_emitterDrip1',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-drip-1'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationPressureSemios_emitterDrip1',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-drip-1'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_emitterDrip1',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-drip-1'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_emitterDrip2',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-drip-2'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationPressureSemios_emitterDrip2',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-drip-2'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_emitterDrip2',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-drip-2'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_emitterFloodFurrow',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-flood-furrow'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationPressureSemios_emitterFloodFurrow',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-flood-furrow'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_emitterFloodFurrow',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-flood-furrow'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_emitterMicrospray',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-microspray'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationPressureSemios_emitterMicrospray',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-microspray'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_emitterMicrospray',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-microspray'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_emitterOther',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-other'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationPressureSemios_emitterOther',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-other'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_emitterOther',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-other'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_emitterOverheadCoolingMicrospray',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-overhead-cooling-microspray'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationPressureSemios_emitterOverheadCoolingMicrospray',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-overhead-cooling-microspray'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_emitterOverheadCoolingMicrospray',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-overhead-cooling-microspray'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_emitterOverheadCoolingSprinkler',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-overhead-cooling-sprinkler'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationPressureSemios_emitterOverheadCoolingSprinkler',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-overhead-cooling-sprinkler'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_emitterOverheadCoolingSprinkler',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-overhead-cooling-sprinkler'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_emitterSprinkler',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-sprinkler'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationPressureSemios_emitterSprinkler',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-sprinkler'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_emitterSprinkler',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-sprinkler'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_postFilter',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-post-filter'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationPressureSemios_postFilter',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-post-filter'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_postFilter',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-post-filter'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_preFilter',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-pre-filter'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationPressureSemios_preFilter',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-pre-filter'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_preFilter',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-pre-filter'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_pump',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-pump'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationPressureSemios_pump',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-pump'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_pump',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-pump'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_systemPressure',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-system-pressure'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'irrigationPressureSemios_systemPressure',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-system-pressure'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationPressureSemios_systemPressure',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-system-pressure'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_PRESSURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_emitterBuriedDrip1',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-buried-drip-1'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_emitterBuriedDrip1',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-buried-drip-1'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_emitterBuriedDrip2',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-buried-drip-2'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_emitterBuriedDrip2',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-buried-drip-2'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_emitterDrip1',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-drip-1'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_emitterDrip1',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-drip-1'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_emitterDrip2',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-drip-2'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_emitterDrip2',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-drip-2'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_emitterFloodFurrow',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-flood-furrow'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_emitterFloodFurrow',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-flood-furrow'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_emitterMicrospray',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-microspray'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_emitterMicrospray',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-microspray'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_emitterOther',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-other'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_emitterOther',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-other'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_emitterOverheadCoolingMicrospray',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-overhead-cooling-microspray'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_emitterOverheadCoolingMicrospray',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-overhead-cooling-microspray'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_emitterOverheadCoolingSprinkler',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-overhead-cooling-sprinkler'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_emitterOverheadCoolingSprinkler',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-overhead-cooling-sprinkler'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_emitterSprinkler',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-sprinkler'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_emitterSprinkler',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-emitter-sprinkler'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_postFilter',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-post-filter'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_postFilter',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-post-filter'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_preFilter',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-pre-filter'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_preFilter',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-pre-filter'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_pump',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-pump'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_pump',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-pump'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_systemPressure',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-system-pressure'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'irrigation_zones',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'irrigationVolumeDurationSemios_systemPressure',
    value_type_group_id: 'irrigation',
    section_id: 'water_management',
    required_measurements: ['water-pressure-system-pressure'],
    permission_id: 'VIEW_IRRIGATION_DETAILS',
    unit_classification_id: 'IRRIGATION_VOLUME_DURATION',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'leafWetnessHours',
    value_type_group_id: 'leaf_wetness',
    section_id: 'weather',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'LEAF_WETNESS_HOURS',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'leafWetnessHours',
    value_type_group_id: 'leaf_wetness',
    section_id: 'weather',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'LEAF_WETNESS_HOURS',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'leafWetnessHours',
    value_type_group_id: 'leaf_wetness',
    section_id: 'weather',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'LEAF_WETNESS_HOURS',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'leafWetnessHours',
    value_type_group_id: 'leaf_wetness',
    section_id: 'weather',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'LEAF_WETNESS_HOURS',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'leafWetnessHours',
    value_type_group_id: 'leaf_wetness',
    section_id: 'weather',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'LEAF_WETNESS_HOURS',
    field_asset: 'regions',
    aggregation: 'HOURLY',
    is_available_for_data_export: false,
  },
  {
    id: 'leafWetnessHours',
    value_type_group_id: 'leaf_wetness',
    section_id: 'weather',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'LEAF_WETNESS_HOURS',
    field_asset: 'regions',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'precipitation',
    value_type_group_id: 'precipitation',
    section_id: 'weather',
    required_measurements: ['rain'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'PRECIPITATION',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'precipitation',
    value_type_group_id: 'precipitation',
    section_id: 'weather',
    required_measurements: ['rain'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'PRECIPITATION',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'precipitation',
    value_type_group_id: 'precipitation',
    section_id: 'weather',
    required_measurements: ['rain'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'PRECIPITATION',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'precipitation',
    value_type_group_id: 'precipitation',
    section_id: 'weather',
    required_measurements: ['rain'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'PRECIPITATION',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'precipitation',
    value_type_group_id: 'precipitation',
    section_id: 'weather',
    required_measurements: ['rain'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'PRECIPITATION',
    field_asset: 'regions',
    aggregation: 'HOURLY',
    is_available_for_data_export: false,
  },
  {
    id: 'precipitation',
    value_type_group_id: 'precipitation',
    section_id: 'weather',
    required_measurements: ['rain'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'PRECIPITATION',
    field_asset: 'regions',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'signalTS5',
    value_type_group_id: 'plant_stress',
    section_id: 'water_management',
    required_measurements: ['tree-dendrometer'],
    permission_id: 'VIEW_PLANT_STRESS_DETAILS',
    unit_classification_id: 'SIGNAL_TS5',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'soilIonicContent',
    value_type_group_id: 'soil',
    section_id: 'water_management',
    required_measurements: ['soil-ionic-content'],
    permission_id: 'VIEW_SOIL_MOISTURE_DETAILS',
    unit_classification_id: 'SOIL_IONIC_CONTENT',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'soilIonicContent',
    value_type_group_id: 'soil',
    section_id: 'water_management',
    required_measurements: ['soil-ionic-content'],
    permission_id: 'VIEW_SOIL_MOISTURE_DETAILS',
    unit_classification_id: 'SOIL_IONIC_CONTENT',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'soilIonicContent',
    value_type_group_id: 'soil',
    section_id: 'water_management',
    required_measurements: ['soil-ionic-content'],
    permission_id: 'VIEW_SOIL_MOISTURE_DETAILS',
    unit_classification_id: 'SOIL_IONIC_CONTENT',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'soilMoisture',
    value_type_group_id: 'soil',
    section_id: 'water_management',
    required_measurements: ['soil-moisture'],
    permission_id: 'VIEW_SOIL_MOISTURE_DETAILS',
    unit_classification_id: 'AWC',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'soilMoisture',
    value_type_group_id: 'soil',
    section_id: 'water_management',
    required_measurements: ['soil-moisture'],
    permission_id: 'VIEW_SOIL_MOISTURE_DETAILS',
    unit_classification_id: 'AWC',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'soilMoisture',
    value_type_group_id: 'soil',
    section_id: 'water_management',
    required_measurements: ['soil-moisture'],
    permission_id: 'VIEW_SOIL_MOISTURE_DETAILS',
    unit_classification_id: 'AWC',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'soilTemperature',
    value_type_group_id: 'soil',
    section_id: 'water_management',
    required_measurements: ['soil-temperature'],
    permission_id: 'VIEW_SOIL_MOISTURE_DETAILS',
    unit_classification_id: 'SOIL_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'soilTemperature',
    value_type_group_id: 'soil',
    section_id: 'water_management',
    required_measurements: ['soil-temperature'],
    permission_id: 'VIEW_SOIL_MOISTURE_DETAILS',
    unit_classification_id: 'SOIL_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'soilTemperature',
    value_type_group_id: 'soil',
    section_id: 'water_management',
    required_measurements: ['soil-temperature'],
    permission_id: 'VIEW_SOIL_MOISTURE_DETAILS',
    unit_classification_id: 'SOIL_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'soilVwc',
    value_type_group_id: 'soil',
    section_id: 'water_management',
    required_measurements: ['soil-moisture'],
    permission_id: 'VIEW_SOIL_MOISTURE_DETAILS',
    unit_classification_id: 'VWC',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'soilVwc',
    value_type_group_id: 'soil',
    section_id: 'water_management',
    required_measurements: ['soil-moisture'],
    permission_id: 'VIEW_SOIL_MOISTURE_DETAILS',
    unit_classification_id: 'VWC',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'soilVwc',
    value_type_group_id: 'soil',
    section_id: 'water_management',
    required_measurements: ['soil-moisture'],
    permission_id: 'VIEW_SOIL_MOISTURE_DETAILS',
    unit_classification_id: 'VWC',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'sprayConditions',
    value_type_group_id: 'spray_conditions',
    section_id: 'sprays',
    required_measurements: [],
    permission_id: 'VIEW_SPRAY_FORECAST',
    unit_classification_id: 'SPRAY_CONDITIONS',
    field_asset: 'blocks',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'sprayConditions',
    value_type_group_id: 'spray_conditions',
    section_id: 'sprays',
    required_measurements: [],
    permission_id: 'VIEW_SPRAY_FORECAST',
    unit_classification_id: 'SPRAY_CONDITIONS',
    field_asset: 'blocks',
    aggregation: 'HOURLY',
    is_available_for_data_export: false,
  },
  {
    id: 'sunrise',
    value_type_group_id: 'weather_conditions',
    section_id: 'weather',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'SUNRISE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'sunset',
    value_type_group_id: 'weather_conditions',
    section_id: 'weather',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'SUNSET',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'temperature_ABOVE',
    value_type_group_id: 'air_temperature',
    section_id: 'weather',
    required_measurements: ['air-temperature-above'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'temperature_ABOVE',
    value_type_group_id: 'air_temperature',
    section_id: 'weather',
    required_measurements: ['air-temperature-above'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'temperature_ABOVE',
    value_type_group_id: 'air_temperature',
    section_id: 'weather',
    required_measurements: ['air-temperature-above'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'temperature_BELOW',
    value_type_group_id: 'air_temperature',
    section_id: 'weather',
    required_measurements: ['air-temperature-below'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'temperature_BELOW',
    value_type_group_id: 'air_temperature',
    section_id: 'weather',
    required_measurements: ['air-temperature-below'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'temperature_BELOW',
    value_type_group_id: 'air_temperature',
    section_id: 'weather',
    required_measurements: ['air-temperature-below'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'temperature_IN',
    value_type_group_id: 'air_temperature',
    section_id: 'weather',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'heatmap_points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'temperature_IN',
    value_type_group_id: 'air_temperature',
    section_id: 'weather',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'heatmap_points',
    aggregation: 'HOURLY',
    is_available_for_data_export: false,
  },
  {
    id: 'temperature_IN',
    value_type_group_id: 'air_temperature',
    section_id: 'weather',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'heatmap_points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'temperature_IN',
    value_type_group_id: 'air_temperature',
    section_id: 'weather',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'temperature_IN',
    value_type_group_id: 'air_temperature',
    section_id: 'weather',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'temperature_IN',
    value_type_group_id: 'air_temperature',
    section_id: 'weather',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'temperature_IN',
    value_type_group_id: 'air_temperature',
    section_id: 'weather',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'temperature_IN',
    value_type_group_id: 'air_temperature',
    section_id: 'weather',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'regions',
    aggregation: 'HOURLY',
    is_available_for_data_export: false,
  },
  {
    id: 'temperature_IN',
    value_type_group_id: 'air_temperature',
    section_id: 'weather',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'regions',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'temperatureInversion_ABOVEvsBELOW',
    value_type_group_id: 'air_temperature',
    section_id: 'weather',
    required_measurements: ['air-temperature-above', 'air-temperature-below'],
    permission_id: 'VIEW_INVERSION_DETAILS',
    unit_classification_id: 'INVERSION',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'temperatureInversion_ABOVEvsBELOW',
    value_type_group_id: 'air_temperature',
    section_id: 'weather',
    required_measurements: ['air-temperature-above', 'air-temperature-below'],
    permission_id: 'VIEW_INVERSION_DETAILS',
    unit_classification_id: 'INVERSION',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'temperatureInversion_ABOVEvsIN',
    value_type_group_id: 'air_temperature',
    section_id: 'weather',
    required_measurements: ['air-temperature-above', 'air-temperature-in'],
    permission_id: 'VIEW_INVERSION_DETAILS',
    unit_classification_id: 'INVERSION',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'temperatureInversion_ABOVEvsIN',
    value_type_group_id: 'air_temperature',
    section_id: 'weather',
    required_measurements: ['air-temperature-above', 'air-temperature-in'],
    permission_id: 'VIEW_INVERSION_DETAILS',
    unit_classification_id: 'INVERSION',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'trunkDisplacement',
    value_type_group_id: 'plant_stress',
    section_id: 'water_management',
    required_measurements: ['tree-dendrometer'],
    permission_id: 'VIEW_PLANT_STRESS_DETAILS',
    unit_classification_id: 'TRUNK_DISPLACEMENT',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'trunkDisplacement',
    value_type_group_id: 'plant_stress',
    section_id: 'water_management',
    required_measurements: ['tree-dendrometer'],
    permission_id: 'VIEW_PLANT_STRESS_DETAILS',
    unit_classification_id: 'TRUNK_DISPLACEMENT',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'trunkDisplacement',
    value_type_group_id: 'plant_stress',
    section_id: 'water_management',
    required_measurements: ['tree-dendrometer'],
    permission_id: 'VIEW_PLANT_STRESS_DETAILS',
    unit_classification_id: 'TRUNK_DISPLACEMENT',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'weatherIcon',
    value_type_group_id: 'weather_conditions',
    section_id: 'weather',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'WEATHER_CONDITIONS',
    field_asset: 'points',
    aggregation: 'CURRENT',
    is_available_for_data_export: false,
  },
  {
    id: 'weatherIcon',
    value_type_group_id: 'weather_conditions',
    section_id: 'weather',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'WEATHER_CONDITIONS',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'weatherIcon',
    value_type_group_id: 'weather_conditions',
    section_id: 'weather',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'WEATHER_CONDITIONS',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: false,
  },
  {
    id: 'weatherIcon',
    value_type_group_id: 'weather_conditions',
    section_id: 'weather',
    required_measurements: ['air-temperature-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'WEATHER_CONDITIONS',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'wetBulb_ABOVE',
    value_type_group_id: 'wet_bulb',
    section_id: 'weather',
    required_measurements: ['air-temperature-above', 'relative-humidity-above'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'wetBulb_ABOVE',
    value_type_group_id: 'wet_bulb',
    section_id: 'weather',
    required_measurements: ['air-temperature-above', 'relative-humidity-above'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'wetBulb_ABOVE',
    value_type_group_id: 'wet_bulb',
    section_id: 'weather',
    required_measurements: ['air-temperature-above', 'relative-humidity-above'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'wetBulb_BELOW',
    value_type_group_id: 'wet_bulb',
    section_id: 'weather',
    required_measurements: ['air-temperature-below', 'relative-humidity-below'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'wetBulb_BELOW',
    value_type_group_id: 'wet_bulb',
    section_id: 'weather',
    required_measurements: ['air-temperature-below', 'relative-humidity-below'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'wetBulb_BELOW',
    value_type_group_id: 'wet_bulb',
    section_id: 'weather',
    required_measurements: ['air-temperature-below', 'relative-humidity-below'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'wetBulb_IN',
    value_type_group_id: 'wet_bulb',
    section_id: 'weather',
    required_measurements: ['air-temperature-in', 'relative-humidity-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'wetBulb_IN',
    value_type_group_id: 'wet_bulb',
    section_id: 'weather',
    required_measurements: ['air-temperature-in', 'relative-humidity-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'wetBulb_IN',
    value_type_group_id: 'wet_bulb',
    section_id: 'weather',
    required_measurements: ['air-temperature-in', 'relative-humidity-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'wetBulb_IN',
    value_type_group_id: 'wet_bulb',
    section_id: 'weather',
    required_measurements: ['air-temperature-in', 'relative-humidity-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'wetBulb_IN',
    value_type_group_id: 'wet_bulb',
    section_id: 'weather',
    required_measurements: ['air-temperature-in', 'relative-humidity-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'regions',
    aggregation: 'HOURLY',
    is_available_for_data_export: false,
  },
  {
    id: 'wetBulb_IN',
    value_type_group_id: 'wet_bulb',
    section_id: 'weather',
    required_measurements: ['air-temperature-in', 'relative-humidity-in'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'regions',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'windDirection',
    value_type_group_id: 'wind',
    section_id: 'weather',
    required_measurements: ['wind'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'WIND_DIRECTION',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'windDirection',
    value_type_group_id: 'wind',
    section_id: 'weather',
    required_measurements: ['wind'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'WIND_DIRECTION',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'windDirection',
    value_type_group_id: 'wind',
    section_id: 'weather',
    required_measurements: ['wind'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'WIND_DIRECTION',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'windDirection',
    value_type_group_id: 'wind',
    section_id: 'weather',
    required_measurements: ['wind'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'WIND_DIRECTION',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'windDirection',
    value_type_group_id: 'wind',
    section_id: 'weather',
    required_measurements: ['wind'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'WIND_DIRECTION',
    field_asset: 'regions',
    aggregation: 'HOURLY',
    is_available_for_data_export: false,
  },
  {
    id: 'windDirection',
    value_type_group_id: 'wind',
    section_id: 'weather',
    required_measurements: ['wind'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'WIND_DIRECTION',
    field_asset: 'regions',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'windMachineActivity',
    value_type_group_id: 'wind_machine',
    section_id: 'equipment',
    required_measurements: ['wind-machine'],
    permission_id: 'VIEW_CONTROLLABLE_FROST_FAN_DETAILS',
    unit_classification_id: 'WIND_MACHINE_ACTIVITY',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'windMachineActivityIntervals',
    value_type_group_id: 'wind_machine',
    section_id: 'equipment',
    required_measurements: ['wind-machine'],
    permission_id: 'VIEW_CONTROLLABLE_FROST_FAN_DETAILS',
    unit_classification_id: 'ACTIVITY_INTERVAL',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'windMachineBattery',
    value_type_group_id: 'wind_machine',
    section_id: 'equipment',
    required_measurements: ['wind-machine'],
    permission_id: 'VIEW_CONTROLLABLE_FROST_FAN_DETAILS',
    unit_classification_id: 'BATTERY',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'windMachineCycles',
    value_type_group_id: 'wind_machine',
    section_id: 'equipment',
    required_measurements: ['wind-machine'],
    permission_id: 'VIEW_CONTROLLABLE_FROST_FAN_DETAILS',
    unit_classification_id: 'CYCLES',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'windMachineFuel',
    value_type_group_id: 'wind_machine',
    section_id: 'equipment',
    required_measurements: ['wind-machine'],
    permission_id: 'VIEW_CONTROLLABLE_FROST_FAN_DETAILS',
    unit_classification_id: 'FUEL_LEVEL',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'windMachineFuel',
    value_type_group_id: 'wind_machine',
    section_id: 'equipment',
    required_measurements: ['wind-machine'],
    permission_id: 'VIEW_CONTROLLABLE_FROST_FAN_DETAILS',
    unit_classification_id: 'FUEL_LEVEL',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'windMachineRPM',
    value_type_group_id: 'wind_machine',
    section_id: 'equipment',
    required_measurements: ['wind-machine'],
    permission_id: 'VIEW_CONTROLLABLE_FROST_FAN_DETAILS',
    unit_classification_id: 'FAN_SPEED',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'windMachineRunTime',
    value_type_group_id: 'wind_machine',
    section_id: 'equipment',
    required_measurements: ['wind-machine'],
    permission_id: 'VIEW_CONTROLLABLE_FROST_FAN_DETAILS',
    unit_classification_id: 'WIND_MACHINE_RUN_TIME',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'windMachineSettings',
    value_type_group_id: 'wind_machine',
    section_id: 'equipment',
    required_measurements: ['wind-machine'],
    permission_id: 'VIEW_CONTROLLABLE_FROST_FAN_DETAILS',
    unit_classification_id: 'DEVICE_SETTINGS',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'windMachineSettings',
    value_type_group_id: 'wind_machine',
    section_id: 'equipment',
    required_measurements: ['wind-machine'],
    permission_id: 'VIEW_CONTROLLABLE_FROST_FAN_DETAILS',
    unit_classification_id: 'DEVICE_SETTINGS',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'windMachineTemperature',
    value_type_group_id: 'wind_machine',
    section_id: 'equipment',
    required_measurements: ['wind-machine'],
    permission_id: 'VIEW_CONTROLLABLE_FROST_FAN_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'windMachineTemperature',
    value_type_group_id: 'wind_machine',
    section_id: 'equipment',
    required_measurements: ['wind-machine'],
    permission_id: 'VIEW_CONTROLLABLE_FROST_FAN_DETAILS',
    unit_classification_id: 'AIR_TEMPERATURE',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
  {
    id: 'windSpeed',
    value_type_group_id: 'wind',
    section_id: 'weather',
    required_measurements: ['wind'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'WIND_SPEED',
    field_asset: 'points',
    aggregation: 'DAILY',
    is_available_for_data_export: true,
  },
  {
    id: 'windSpeed',
    value_type_group_id: 'wind',
    section_id: 'weather',
    required_measurements: ['wind'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'WIND_SPEED',
    field_asset: 'points',
    aggregation: 'HOURLY',
    is_available_for_data_export: true,
  },
  {
    id: 'windSpeed',
    value_type_group_id: 'wind',
    section_id: 'weather',
    required_measurements: ['wind'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'WIND_SPEED',
    field_asset: 'points',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: true,
  },
  {
    id: 'windSpeed',
    value_type_group_id: 'wind',
    section_id: 'weather',
    required_measurements: ['wind'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'WIND_SPEED',
    field_asset: 'regions',
    aggregation: 'DAILY',
    is_available_for_data_export: false,
  },
  {
    id: 'windSpeed',
    value_type_group_id: 'wind',
    section_id: 'weather',
    required_measurements: ['wind'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'WIND_SPEED',
    field_asset: 'regions',
    aggregation: 'HOURLY',
    is_available_for_data_export: false,
  },
  {
    id: 'windSpeed',
    value_type_group_id: 'wind',
    section_id: 'weather',
    required_measurements: ['wind'],
    permission_id: 'VIEW_WEATHER_DETAILS',
    unit_classification_id: 'WIND_SPEED',
    field_asset: 'regions',
    aggregation: 'UNAGGREGATED',
    is_available_for_data_export: false,
  },
]
